import { z } from 'zod';
import { addressSchema } from '../common/address.js';
export const prospectSearchQuerySchema = z.object({
    keyword: z.string().trim().min(1).max(150),
    location: z.string().trim().min(1).max(200),
    radiusKm: z.coerce.number().min(0.5).max(50).default(5),
});
/** Deliberately just what Google actually reports — no invented "likely to
 * convert" score or online-presence grade. `alreadyAdded` is the one bit of
 * CRM-side context: whether a Company already exists with this website or
 * phone number, computed at search time. */
/** Computed by fetching the business's own reported website (never a
 * Google-reported field) — best-effort and `null` whenever that fetch
 * couldn't be attempted or didn't resolve in time, not a false "no
 * presence". See prospecting.service.ts's `detectOnlinePresence`. */
export const onlinePresenceSchema = z.object({
    isWordPress: z.boolean(),
    socialLinks: z.array(z.enum(['facebook', 'instagram', 'linkedin', 'x'])),
});
export const prospectResultSchema = z.object({
    placeId: z.string(),
    name: z.string(),
    address: addressSchema,
    phone: z.string().nullable(),
    website: z.string().nullable(),
    rating: z.number().nullable(),
    reviewCount: z.number().int().nullable(),
    googleMapsUri: z.string().nullable(),
    alreadyAdded: z.boolean(),
    onlinePresence: onlinePresenceSchema.nullable(),
});
export const resolveGoogleMapsUrlSchema = z.object({
    googleMapsUrl: z.string().trim().url().max(1000),
});
export const placeAutocompleteQuerySchema = z.object({
    input: z.string().trim().min(1).max(200),
});
export const placeAutocompleteSuggestionSchema = z.object({
    placeId: z.string(),
    mainText: z.string(),
    secondaryText: z.string().nullable(),
});
/** `markers` is "lat,lng|lat,lng|..." — a plain delimited string rather
 * than a JSON array, since this travels as a GET query param behind an
 * `<img src>` the browser requests directly (no way to send a JSON body
 * from an <img> tag). */
export const staticMapQuerySchema = z.object({
    lat: z.coerce.number(),
    lng: z.coerce.number(),
    markers: z.string().trim().max(2000).optional(),
});
//# sourceMappingURL=schemas.js.map